import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/RachelHill_Pet/subs.vtt';
import poster from '@/static/assets/reviews/RachelHill_Pet/video.png';

export const RachelHill: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Rachel',
  videoUrl: `${ASSETS_URL}/pet/RachelHill_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
